import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useAuth } from "@/auth/AuthContext";

export default function TopNav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const getRoleBadge = () => {
    if (user?.role === "admin") {
      return (
        <Badge
          data-testid="nav-role-badge"
          className="bg-violet-50 text-violet-700 border-violet-200"
          variant="outline"
        >
          Admin
        </Badge>
      );
    } else if (user?.role === "supervisor") {
      return (
        <Badge
          data-testid="nav-role-badge"
          className="bg-amber-50 text-amber-700 border-amber-200"
          variant="outline"
        >
          Supervisor
        </Badge>
      );
    } else {
      return (
        <Badge
          data-testid="nav-role-badge"
          className="bg-emerald-50 text-emerald-700 border-emerald-200"
          variant="outline"
        >
          User
        </Badge>
      );
    }
  };

  return (
    <div className="sticky top-0 z-30 border-b border-slate-200 bg-white/85 backdrop-blur" data-testid="topnav-container">
      <div className="mx-auto max-w-6xl px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Link
            to="/dashboard"
            data-testid="nav-home-link"
            className="text-slate-900 font-semibold tracking-tight"
          >
            POD Console
          </Link>
          {getRoleBadge()}
        </div>

        <div className="flex items-center gap-3">
          <div className="hidden sm:block text-sm text-slate-600" data-testid="nav-user-email">
            {user?.email}
          </div>
          <Link
            to="/reports"
            data-testid="nav-reports-link"
            className="text-sm text-slate-700 hover:text-slate-900"
          >
            Reports
          </Link>
          {/* Supervisor can see Users (read-only) */}
          {(user?.role === "admin" || user?.role === "supervisor") && (
            <Link
              to="/admin/users"
              data-testid="nav-admin-users-link"
              className="text-sm text-slate-700 hover:text-slate-900"
            >
              Users
            </Link>
          )}
          {/* Only Admin can see Groups and Settings */}
          {user?.role === "admin" && (
            <>
              <Link
                to="/groups"
                data-testid="nav-groups-link"
                className="text-sm text-slate-700 hover:text-slate-900"
              >
                Groups
              </Link>
              <Link
                to="/settings"
                data-testid="nav-settings-link"
                className="text-sm text-slate-700 hover:text-slate-900"
              >
                Settings
              </Link>
            </>
          )}
          <Button
            data-testid="nav-logout-button"
            variant="secondary"
            className="rounded-full bg-white border border-slate-300 text-slate-800 hover:bg-slate-50"
            onClick={async () => {
              await logout();
              navigate("/login");
            }}
          >
            Logout
          </Button>
        </div>
      </div>
    </div>
  );
}
